import { useCallback } from "react";

export const NOTIFY_UPLOAD_CUSTOM_EVENT_NAME = "sample_upload";

const useUploadNotifier = () => {
  const notifyUpload = useCallback(() => {
    const customEvent = new CustomEvent(NOTIFY_UPLOAD_CUSTOM_EVENT_NAME);

    window.dispatchEvent(customEvent);
  }, []);

  return { notifyUpload };
};

export default useUploadNotifier;
